<template>
  <div />
</template>

<script>

// This component is a little non-standard in that
// it relies on the state binding to ensure that
// we have a tracking ID loaded before executing
// the gtag script. Since the work is done via the
// imported gtag script, there is no template to
// render here.

import { bootstrap, setOptions } from 'vue-gtag'

export default {
  name: 'GoogleAnalytics',
  props: {
    ga_id: {  // eslint-disable-line
      type: String,
      required: true,
      default: '',
    },
  },
  mounted: function () {
    if (this.ga_id !== '') {
      setOptions({
        config: { id: this.ga_id },
      })
      bootstrap().then(gtag => {
        // Since we are running a single page app, and
        // because we do not bootstrap immediately, we
        // send an initial page view when the gtag is
        // loaded and ready.
        this.$gtag.pageview({ page_path: '/' })
      })
    }
  },
}
</script>
